import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
type Tome = {
  number: string;
  title: string;
  subtitle: string;
  body: string;
  promise: string;
  flag?: string;
};
const tomes: Tome[] = [{
  number: '01',
  title: 'Diagnosi Profonda e Onboarding',
  subtitle: 'Fase Fondamenta (sedute 1-3) · schede WS-01 → WS-05',
  body: 'Dal colloquio esplorativo alla prima mappa condivisa. Il Colloquio Esplorativo strutturato, la Mappa del Percorso co-creata, l’accordo di percorso e la definizione delle tre fasi con il cliente.',
  promise: 'Il cliente sa dove sta andando prima ancora della seconda seduta.'
}, {
  number: '02',
  title: 'Il Nucleo: Riscrivere le Credenze',
  subtitle: 'Fase Fondamenta / Slancio · schede WS-06 → WS-10',
  body: 'Il lavoro sugli schemi mentali senza sconfinare nella psicoterapia. I 5 archetipi di cliente per calibrare l’approccio, i protocolli di reframe e le schede di lavoro sulle credenze limitanti.',
  promise: 'Smetti di girare intorno al blocco: lo nomini, lo lavori e lo lasci per iscritto.'
}, {
  number: '03',
  title: 'Dall’intuizione all’azione',
  subtitle: 'Fase Slancio (sedute 4-7) · schede WS-11 → WS-13',
  body: 'Il piano di lavoro, i micro-impegni tra una seduta e l’altra e l’Ancoraggio di Progresso: il dispositivo che rende visibile quello che il cliente ha già ottenuto.',
  promise: 'L’intuizione diventa un comportamento che il cliente può vedere.'
}, {
  number: '04',
  title: 'Il cliente bloccato',
  subtitle: 'Trasversale · schede WS-14 → WS-16',
  body: 'Cosa fare esattamente quando la resistenza arriva. Il protocollo per la Crisi della Quarta Seduta, gli script per il cliente che rimanda, che minimizza o che sparisce, e il ripristino della mappa quando il percorso si è perso.',
  promise: 'La seduta numero quattro smette di essere quella che decide tutto per caso.',
  flag: '★ Il cuore del sistema'
}, {
  number: '05',
  title: 'Chiudere bene',
  subtitle: 'Fase Integrazione (sedute 8-10) · schede WS-17 → WS-19',
  body: 'La seduta di bilancio, il dossier finale del percorso, il passaggio all’autonomia e la richiesta di feedback fatta nel momento giusto.',
  promise: 'Il percorso finisce con un documento in mano, non con un silenzio.'
}, {
  number: '06',
  title: 'La pratica professionale',
  subtitle: 'Fuori seduta · schede WS-20 → WS-23',
  body: 'Percorso contro sedute sciolte, la sessione conoscitiva, le tariffe, l’accordo professionale, la privacy e il GDPR, la Legge 4/2013 e l’attestato di qualità dei servizi, il cruscotto trimestrale della pratica.',
  promise: 'La tua attività smette di essere un’attività e diventa una professione.'
}];
const includes = ['Schede di lavoro compilabili, da usare in seduta', 'Script parola per parola per i momenti difficili', 'Documenti da consegnare al cliente', 'Checklist stampabili', 'Tutto adattato al quadro professionale italiano'];
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-cream" data-id="element-216" data-mp="11lbkjg1hopua">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-217" data-mp="11nej4ogpjram">
        <h2 id="tomes-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-218" data-mp="16l6anhdfxbea">
          Sei volumi. Un percorso intero. Zero improvvisazione.
        </h2>

        <ul className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-219" data-mp="dxtxtyx30hy6">
          {tomes.map(tome => <li key={tome.number} className="flex flex-col rounded-2xl bg-white border border-cream-dark shadow-card p-6" data-id="element-220" data-mp="ispujcd9jthm">
              <div className="flex items-center justify-between gap-3" data-id="element-221" data-mp="roypadqaq3xf">
                <span className="font-serif font-bold text-sm text-sage tracking-[0.14em] uppercase" data-id="element-222" data-mp="3rbov2s1d9gnj">
                  Volume {tome.number}
                </span>
                {tome.flag && <span className="rounded-full bg-terracotta-soft text-terracotta text-[10px] font-bold uppercase tracking-wider px-2.5 py-1" data-id="element-223" data-mp="3c72pwp53ap4t">
                    {tome.flag}
                  </span>}
              </div>

              <h3 className="mt-3 font-serif font-bold text-xl sm:text-2xl text-ink leading-snug" data-id="element-224" data-mp="3lz00pus6rf30">
                {tome.title}
              </h3>
              <p className="mt-1.5 italic text-sm text-ink-muted" data-id="element-225" data-mp="3uxu361s76zoh">
                {tome.subtitle}
              </p>

              <p className="mt-4 text-[15px] leading-relaxed text-ink-soft flex-grow" data-id="element-226" data-mp="3py8u2yjbday1">
                {tome.body}
              </p>

              <p className="mt-5 pt-4 border-t border-cream-dark font-semibold text-ink" data-id="element-227" data-mp="8qdnnfcji1ky">
                <span className="text-sage" aria-hidden="true" data-id="element-228" data-mp="3su17s5ouihx">
                  →{' '}
                </span>
                {tome.promise}
              </p>
            </li>)}
        </ul>

        <div className="mt-10 rounded-2xl bg-sage-tint border border-sage-soft p-6 sm:p-7" data-id="element-229" data-mp="25l9v2jlf4ir9">
          <p className="font-serif font-bold text-ink text-lg text-center" data-id="element-230" data-mp="l1wlek6iisa6">
            Dentro ogni volume
          </p>
          <ul className="mt-5 flex flex-wrap justify-center gap-3" data-id="element-231" data-mp="q2kedbeaxj71">
            {includes.map(item => <li key={item} className="inline-flex items-center gap-2 rounded-full bg-white border border-sage-soft px-3.5 py-2 text-xs sm:text-sm font-medium text-ink" data-id="element-232" data-mp="b9qsn88fs6tx">
                <CheckIcon className="w-4 h-4 text-vital" aria-hidden="true" data-id="element-233" data-mp="6c8gza31bdi8" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-234" data-mp="3ok7rt5b3bihn">
          <CtaButton data-id="element-235" data-mp="3tgep69pf7lnz">Voglio il sistema completo</CtaButton>
        </div>
      </div>
    </section>;
}